<template>
  <div >
    <div   class="shop_name_wrapper">
      <div class="shop_pic_wrapper">
        <img  :src="item.pict_url" class="shop_pic" />
      </div>
      <div class="shop_content_wrapper">
        <p class="shop_name">{{item.shop_title}}</p>
        <p class="shop_style"><span class="shop_style_inner">{{item.shop_title}}</span></p>
        <p class="shop_detail">
          <span class="shop_detail_cell">宝贝描述：<span class="color_red">5</span></span>
          <span class="shop_detail_cell">买家服务：<span class="color_red">4.9</span></span>
          <span class="shop_detail_cell">物流速度：<span class="color_red">4.2</span></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
export default {
  name:"shopName",
  props:['item'],
  created() {
    console.log(this.item)
    //console.log("ok")
  }

}
</script>
<style lang="stylus">
  .shop_name_wrapper
    padding:20px
    background:#fff
    display:flex
    justify-content:space-between
    margin-top:10px
    .shop_pic_wrapper
      width:105px
      height:105px
      .shop_pic
        width:105px
        height:105px
        display:block
    .shop_content_wrapper
      width:570px
      .shop_name
        font-size:24px
        color:#666
      .shop_style
        margin:5px 0
        .shop_style_inner
          background:#f61108
          height:28px
          padding:0 10px
          border-radius:14px
          font-size:18px
          color:#fff
      .shop_detail
        display:flex
        font-size:20px
        color:#999
        .shop_detail_cell
          flex:1
          .color_red
            color:#f50


</style>



// WEBPACK FOOTER //
// src/components/item/shopName.vue